<template>
    <div :class="{'w-full sm:w-1/3 lg:w-64 sm:mt-4': !block, 'w-full sm:mt-1': block}" class="mt-0 px-0 sm:px-2" class2="px-4 sm:mx-auto">
        <div class="card card-product rounded shadow-none transition duration-200 border border-gray-300 hover:border-gray-400 hover:shadow-md focus:shadow-inner">
            <div v-if="!manage && !block && user" :class="{'bg-white rounded-full hover:bg-gray-100 hover:shadow': block}" class="hidden sm:block absolute t-10 r-10 p-2">
                <follow-product-button :product="product" class="z-10" :unstyled="true" :tooltip-placement="tooltipPlacement" subscribe-tooltip="Alerts are disabled for this product." unsubscribe-tooltip="Alerts are enabled for this product.">
                    <template slot="subscribe">
                        <i class="far fa-bell"></i>
                    </template>
                    <template slot="unsubscribe">
                        <i class="fas fa-bell text-blue-600"></i>
                    </template>
                </follow-product-button>
            </div>

            <!-- <div v-cloak v-if="product.num_sales > 50" class="marker marker-ribbon marker-warning absolute t-10 left-0 text-sm hidden sm:block">
                HOT
                <!-- <fa-icon :icon="['fas', 'fire-alt']" class="ml-2" /> -->
                <!-- <i class="far fa-fire-alt ml-2"></i> -->
            <!-- </div> -->
            <!-- <div v-cloak v-if="isNew" class="marker marker-ribbon marker-success absolute t-10 left-0 text-sm hidden sm:block">
                NEW
            </div> -->

            <div v-if="!block && listing">
                <div v-cloak v-if="listing.stocked === true" class="marker marker-ribbon marker-success absolute t-10 left-0">
                    In Stock
                </div>
                <div v-cloak v-else class="marker marker-ribbon marker-warning absolute t-10 left-0">
                    Sold Out
                </div>
            </div>

            <div @click.prevent="openProduct" :class="{'sm:block sm:text-center': !block, 'py-1': block}" class="card-body text-left cursor-pointer border-0 flex items-center">
                <img v-if="product.image_url" :data-src="product.image_url" :alt="product.name" :class="{'h-20 w-20 sm:h-32': !size, 'h-12 w-12 sm:h-16': size && size === 'sm', 'sm:w-full': !block}" class="lazyload object-contain" class2="card-img" />

                <div :class="{'sm:ml-0 sm:block': !block, 'mr-5': !manage && user}" class="ml-5 flex flex-wrap items-center">
                    <h5 :class="{'sm:h-16 sm:mt-6 overflow-hidden text-truncate2': !block, 'text-lg sm:text-base': !size, 'text-sm sm:text-sm': size && size === 'sm'}" class="mt-0 mb-0 font-semibold" class2="text-base">
                        <a @click.prevent="openProduct" :href="product.link">{{ product.name }}</a>
                    </h5>

                    <div v-if="manage" class="block sm:hidden w-full mt-3">
                        <follow-product-button :product="product" btn-class="btn-xs text-xs" :manage="true" />
                    </div>
                </div>

                <!-- <div class="hidden sm:block w-full mt-3">
                    <button type="button" class="btn btn-block btn-primary border-2 rounded-full font-semibold" class2="text-lg">
                        View
                    </button>
                </div> -->

                <!-- <div class="mt-2 text-xs text-gray-600 absolute left-0 bottom-0">
                    Tracking {{ product.listings_count }} listings
                </div> -->
            </div>

            <div v-if="manage" class="card-footer bg-gray-100 text-center hidden sm:block">
                <follow-product-button :product="product" btn-class="btn-xs sm:btn-block text-xs sm:text-sm" :manage="true" />
            </div>
        </div>
    </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
    props: {
        product: {
            type: Object,
            required: true
        },

        listing: {
            type: Object,
            default: null
        },

        size: {
            type: String,
            default: null
        },

        block: {
            type: Boolean,
            default: false
        },

        manage: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({}),

    created() {},

    mounted() {},

    beforeDestroy() {},

    computed: {
        isNew() {
            const createdAt = this.product.created_at;
            if (isEmpty(createdAt)) return false;
            return false;
            // var created = moment(createdAt);
            // var filter = moment().subtract(1, 'days');
            // return created.isAfter(filter);
        },

        tooltipPlacement() {
            if (this.block) return 'left';
            return 'top';
        }
    },

    methods: {
        openProduct($event) {
            $event.preventDefault();
            $event.stopPropagation();

            window.location.href = this.product.link;
        }
    }
}
</script>

<style lang="scss" scoped>
.card-product {
    .card-body {
        border-left-width: 0;
        border-right-width: 0;
    }
}
</style>
